import AdjustedTimesController from './adjusted_times_controller';
import ApproveChargesController from './approve_charges_controller';
import BoardController from './board_controller';
import CopyPromptController from './copy_prompt_controller';
import FileUploadController from './file_upload_controller';
import PaymentsController from './payments_controller';
import StripePaymentFormController from './stripe_payment_form_controller';
import RecentTasksController from './recent_tasks_controller';
import RemoteSelectController from './remote_select_controller';
import SuggestedTaskController from './suggested_task_controller';
import TimerController from './timer_controller';

export const controllers = [
  { id: 'adjusted-times', controller: AdjustedTimesController },
  { id: 'approve-charges', controller: ApproveChargesController },
  { id: 'board', controller: BoardController },
  { id: 'copy-prompt', controller: CopyPromptController },
  { id: 'file-upload', controller: FileUploadController },
  { id: 'payments', controller: PaymentsController },
  { id: 'recent-tasks', controller: RecentTasksController },
  { id: 'remote-select', controller: RemoteSelectController },
  { id: 'suggested-task', controller: SuggestedTaskController },
  { id: 'timer', controller: TimerController },
  { id: 'stripe-payment-form', controller: StripePaymentFormController },
];
